import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { Device } from './device.type';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {

  constructor(
    private http: HttpService
  ) { }

  /**
   * Gibt eine Liste von Geräten zurück
   * @param {string} searchText Suchttext nachdem gefiltert werden soll
   * @param {number} addressId Id der Adresse, -1 für alle
   * @param {number} offset Wie viele Geräte sollen übersprungen werden
   * @param {number} limit Wie viele Geräte sollen maximal geladen werden
   * @returns 
   */
  public async getAllDevices(searchText: string, addressId: number, offset: number, limit: number): Promise<HttpFunctionResult<Device[]>>{
    return await this.http.GET<Device[]>({
        path: `devices?searchText=${searchText}&addressId=${addressId}&limit=${limit}&offset=${offset}`,
    })
  }

  /**
   * Gibt ein Gerät anhand der Id zurück
   * @param {number} deviceId Id des Gerätes
   * @returns 
   */
  public async getDeviceById(deviceId: number): Promise<HttpFunctionResult<Device>>{
    return await this.http.GET<Device>({
      path: `devices/${deviceId}`,   
    })
  }

  /**
   * Fügt ein Gerät einem Ticket hinzu
   * @param {Device} device Das Geräte welches hinzugefügt werden soll
   * @param {number} ticketId die Id des Tickets
   * @param {number} workstepId die Id des Arbeitsschrittes
   * @returns 
   */
  public async addDeviceToTicket(device: Device, ticketId: number, workstepId: number): Promise<HttpFunctionResult<number>>{
    return await this.http.POST<Device, number>({
      path: `devices/toTicket?ticketId=${ticketId}&workstepId=${workstepId}`,
      body: device
    })
  }

}
